import {

  GET_QUOTES_FAIL,
  GET_QUOTES_SUCCESS,
 
  GET_QUOTE_DETAIL_SUCCESS,
  GET_QUOTE_DETAIL_FAIL,


  DELETE_QUOTE_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  quotes: [],

  quote: {},
}

const Quotes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QUOTES_SUCCESS:
      return {
        ...state,
        quotes: action.payload,
      }

    case GET_QUOTES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
 
    case GET_QUOTE_DETAIL_SUCCESS:
      return {
        ...state,
        quote: action.payload,
      }

    case GET_QUOTE_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_QUOTE_SUCCESS: 
      return {
        ...state,
        quotes: state.quotes.docs.filter(
          quote => quote._id !== action.payload.id
        ),
      }

    default:
      return state
  }
}

export default Quotes
